import React, { lazy } from "react";
//import QuickActionsPanel from "../../../app/partials/layout/QuickActionsPanel";
//import QuickPanelToggler from "./QuickPanelToggle";
//import LanguageSelector from "../../../app/partials/layout/LanguageSelector";
//import UserProfile from "../../../app/partials/layout/UserProfile";
//import { toAbsoluteUrl } from "../../utils/utils";

const SearchMenu = lazy(() =>
  import("../../../app/partials/content/SearchMenu")
);

const SwitchTheme = lazy(() =>
  import("../../../app/partials/content/SwitchTheme")
);

const UserMenu = lazy(() =>
  import("../../../app/partials/content/UserMenu")
);


export default class Topbar extends React.Component {
  render() {
    return (
      <div className="kt-header__topbar">
        <SearchMenu />

        {/* <QuickActionsPanel
          bgImage={toAbsoluteUrl("/media/misc/bg-2.jpg")}
          skin="dark"
          iconType=""
          useSVG="true"
          gridNavSkin="light"
        /> */}

        {/* <QuickPanelToggler /> */}


        {/* <LanguageSelector iconType="" /> */}

        {/* <UserProfile showAvatar={true} showHi={true} showBadge={false} /> */}
        <UserMenu />
        <SwitchTheme />
      </div>
    );
  }
}
